import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { RouterModule } from '@angular/router';
import { AccountGroupService } from '@galaxy/account-group';
import { TranslateModule } from '@ngx-translate/core';
import { HighlightsComponent } from './highlights.component';
import { HighlightsService } from './highlights.service';
import { ldExpiredToken, ldExpiringToken, ldRenewsInToken, lspExpiredToken, lspExpiringToken } from './tokens';

@NgModule({
  imports: [CommonModule, MatCardModule, MatIconModule, TranslateModule, MatListModule, RouterModule],
  declarations: [HighlightsComponent],
  exports: [HighlightsComponent],
  providers: [
    HighlightsService,
    { provide: ldExpiredToken, useClass: AccountGroupService },
    { provide: ldExpiringToken, useClass: AccountGroupService },
    { provide: ldRenewsInToken, useClass: AccountGroupService },
    { provide: lspExpiredToken, useClass: AccountGroupService },
    { provide: lspExpiringToken, useClass: AccountGroupService },
  ],
})
export class HighlightsModule {}
